import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { handleAPI } from '../../utils/api/api';
import { generateUniqueEnoughId, getCookie, getStoredAbilities, removeCookie, setCookie, transformPermissions } from '../../utils/helper/helper';
import { TENANT } from '../../env';

const initialState = {
  auth: {},
  instance_id: generateUniqueEnoughId(),
  abilities: getStoredAbilities(),
  role: localStorage.getItem('role') ? localStorage.getItem('role') : {},
  authenticate: false,
  isLoading: false,
  error: null,
  rememberMe: false,
  timezone: getCookie('timezone'),
};

var rememberMe = false;

const broadcastReload = (id) => {
  const channel = new BroadcastChannel('reload');
  channel.postMessage({ type: 'auth', id });
  channel.close();
};

export const authUser = createAsyncThunk('auth/Login', async (data) => {
  const loginResponse = await handleAPI('platform/auth/login', 'post', '', data);

  const userId = loginResponse.data.data.id;
  const token = loginResponse.data?.meta?.token;

  const permissionsResponse = await handleAPI(`platform/roles/permissions_template?user_id=${userId}`, 'get', null, null, 'json', {
    headers: {
      Authorization: token,
    },
  });

  rememberMe = data.rememberMe;

  return {
    loginData: loginResponse,
    permissions: permissionsResponse.data.permissions,
  };
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    Logout: (state) => {
      state.authenticate = false;
      // state.abilities = {};
      localStorage.removeItem('role');
      localStorage.removeItem('abilities');
      removeCookie('token');
      removeCookie('email');
      removeCookie('tenant');
      removeCookie('isReportsLoggedIn');
      broadcastReload(state.instance_id);
    },
    setTimezone: (state, action) => {
      state.timezone = action.payload;
      setCookie('timezone', action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(authUser.fulfilled, (state, action) => {
      const { loginData, permissions } = action.payload;
      state.auth = loginData;

      const userRole = loginData.data.data.attributes.role?.role_template;
      state.role = userRole;

      if (userRole) {
        localStorage.setItem('role', userRole);
      }

      if (permissions) {
        const transformedAbilities = transformPermissions(permissions);
        localStorage.setItem('abilities', JSON.stringify(transformedAbilities));
        state.abilities = transformedAbilities;
      }

      state.authenticate = true;
      state.isLoading = false;

      const userAttributes = loginData.data.data.attributes;

      const tZone = userAttributes.timezone ? userAttributes.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone;
      state.timezone = tZone;

      setCookie('token', loginData.data?.meta?.token || '', rememberMe);
      setCookie('email', userAttributes.email, rememberMe);
      setCookie('username', userAttributes.username, rememberMe);
      setCookie('timezone', tZone, rememberMe);
      setCookie('tenant', TENANT, rememberMe, true);
      broadcastReload(state.instance_id);
    });
    builder.addCase(authUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { Logout, setTimezone } = authSlice.actions;
export const selectAbilities = (state) => state.auth.abilities;

export default authSlice.reducer;
